module.exports = __webpack_public_path__ + "img/Roof.5bcc25dd.svg";